import { AppFixture, ActionFixture } from '../types';

/**
 * Remove the `includeUpdates` need from the array of returned needs.
 * Sets the `includeUpdates` param to "new".
 */
const removeIncludeUpdatesNeedAndSetParam = (): ActionFixture => ({
  needs: (needs) => needs.filter(({ key }) => key !== 'includeUpdates'),
  params: (params) => ({ ...params, includeUpdates: 'new' }),
});

const fixture: AppFixture = {
  attendeeList: removeIncludeUpdatesNeedAndSetParam(),
  eventList: removeIncludeUpdatesNeedAndSetParam(),
  contactList: removeIncludeUpdatesNeedAndSetParam(),
};

export default fixture;
